<template>
  <BaseCard
    variant="product"
    class="ui-w-full m-[5px] ui-text-charcoal-default"
    data-test-id="relatedProductWidget"
  >
    <Stack direction="col">
      <NuxtLink :to="content.url" class="min-h-[225px]">
        <ProductCardImage
          :image="content.image"
          :desktopImage="content.desktopImage"
          :alt="`${content.title} product image`"
          imageLoading="lazy"
          :is-placeholder="false"
          :related-product="true"
          class="mb-xs"
          data-test-id="productImage"
        />

        <Text
          style="min-height: 75px"
          size="sm"
          class="px-xs"
          data-test-id="productName"
        >
          {{ content.title }}
        </Text>
      </NuxtLink>

      <Stack direction="col" class="px-xs pb-xs" v-if="props.branchSelected">
        <Stack v-if="props.signedIn" gap="2xs" direction="col">
          <Stack gap="2xs">
            <Text weight="semi" class="whitespace-nowrap" data-test-id="user">
              {{ props.userName }}
            </Text>
            <Text class="whitespace-nowrap">your price is</Text></Stack
          >
          <Stack gap="2xs" align="end">
            <Text weight="bold" size="xl" data-test-id="productPrice">
              {{ toCurrency({ value: Number(content.offerPriceEach) }) }}
            </Text>
            <Text weight="bold" size="xs">{{ content.unit }}</Text>
            <Text class="whitespace-nowrap" size="xs" data-test-id="vat">
              {{ content.hasVat ? "Inc. VAT" : "Ex. Vat" }}
            </Text>
          </Stack>
        </Stack>
        <Stack v-else direction="col">
          <Text size="sm">
            <button
              @click="handleCardSignIn"
              class="text-mkm-blue-light font-bold"
              data-test-id="signInBtn"
            >
              Sign in
            </button>
            for your account price</Text
          >
          <Stack gap="2xs" align="end">
            <Text weight="bold" size="xl" data-test-id="productPriceEach">
              £{{ Number(content.priceEach).toFixed(2) }}
            </Text>
            <Text weight="bold" class="whitespace-nowrap" size="xs">
              {{ content.unit }}
            </Text>
            <Text class="whitespace-nowrap text-charcoal-light" size="xs">
              {{ content.vat ? "Inc. VAT" : "Ex. VAT" }}
            </Text>
          </Stack>
          <Text>{{ content.offerPrice }}</Text>
        </Stack>
      </Stack>
      <Stack direction="col" class="px-xs pb-xs" v-else>
        <CardBranchSelect
          v-if="!branchSelected"
          @card-branch-select="handleCardBranchSelect"
          data-test-id="selectBranchBtn"
        />
      </Stack>
    </Stack>
  </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "./BaseCard.vue";
import { RelatedProductCardProps } from "./types";
import ProductCardImage from "./ProductCardImage.vue";
import CardBranchSelect from "./CardBranchSelect.vue";
import { toCurrency } from "mkm-avengers";

const props = defineProps<RelatedProductCardProps>();

const emit = defineEmits<{
  (event: "cardBranchSelect"): void;
  (event: "relatedCardSignIn"): void;
}>();

const handleCardBranchSelect = () => emit("cardBranchSelect");

const handleCardSignIn = () => emit("relatedCardSignIn");
</script>
